module.exports = __webpack_public_path__ + "img/yw.8328a28e.png";